import { apiRequest } from '@/common/utils/request.common'
import { normalizeBaseHome } from '@/common/normalize/normalize-base-home'
import { API_BASE_URL, HTTP_METHOD_GET } from '@/common/utils/request.const'
import { HOME_API_ERROR_RESPONSE } from '@/common/resources/home-api-error-response'

/**
 * 카테고리 서브 홈 데이터 catalog api
 * @param mainCategory
 * @param subCategory
 * @returns {Promise<{data: {layout: {filter: *, catalog: *, campaign: *, gnb: *, category: *}, description: string, id: string}}|AxiosResponse>}
 */
export const getCategorySubHomeData = async ({
  mainCategory = '',
  subCategory = '',
}) => {
  try {
    const response = await apiRequest({
      url: `${API_BASE_URL}/v1/category/${mainCategory}/sub/${subCategory}`,
      method: HTTP_METHOD_GET,
    })

    response.data = normalizeBaseHome(response?.data?.data)

    return response
  } catch (e) {
    console.error(`Get Category Sub Home Data Error ${e.message}`)

    return HOME_API_ERROR_RESPONSE
  }
}
